import { useEffect, useState } from 'react'
import { authApi } from '../api/auth'
import { useAuthStore } from '../store/authStore'

export function useAuth() {
  const [isLoading, setIsLoading] = useState(true)
  const { isAuthenticated, user, setAuth, logout } = useAuthStore()

  useEffect(() => {
    const token = localStorage.getItem('pm_token')
    if (!token) {
      setIsLoading(false)
      return
    }

    authApi
      .me()
      .then((res) => {
        const userData = res.data.data
        setAuth(userData, token)
      })
      .catch(() => {
        logout()
      })
      .finally(() => {
        setIsLoading(false)
      })
  }, [])

  return { isLoading, isAuthenticated, user }
}
